export const groups = [
  { label: 'District', value: 'district' },
  { label: 'School', value: 'school' },
];

export const sections = [
  { label: 'All Sections', value: 1 },
  { label: 'All Students', value: 2 },
  { label: 'AP Calculus BC Jane Dapkus School Section 1', value: 3 },
  { label: 'AP Calculus BC Jane Dapkus School Section 2', value: 4 },
];

export const categories = [
  { label: 'Units', value: 1 },
  { label: 'Topics', value: 2 },
  { label: 'Skills', value: 3 },
];

export const questionTypes = [
  { label: 'MCQ', value: 'MCQ' },
  { label: 'FRQ', value: 'FRQ' },
];

export const students = [
  {
    label: 'All Students',
    value: '3333',
    type: 'STUDENT_TYPE',
    firstName: 'Todd',
    lastName: 'Atwell',
    id: '884637-129',
  },
  {
    label: 'Todd Atwell',
    value: '884637-129',
    type: 'STUDENT_TYPE',
    firstName: 'Todd',
    lastName: 'Atwell',
    id: '884637-129',
  },
  {
    label: 'Meagan Burkhart',
    value: '884637-135',
    type: 'STUDENT_TYPE',
    firstName: 'Meagan',
    lastName: 'Burkhart',
    id: '884637-135',
  },
  {
    label: 'Micheal Daniel',
    value: '884637-142',
    type: 'STUDENT_TYPE',
    firstName: 'Micheal',
    lastName: 'Daniel',
    id: '884637-142',
  },
  {
    label: 'Michael Domingue',
    value: '884637-148',
    type: 'STUDENT_TYPE',
    firstName: 'Michael',
    lastName: 'Domingue',
    id: '884637-148',
  },
  {
    label: 'Ricki Fischer',
    value: '884638-107',
    type: 'STUDENT_TYPE',
    firstName: 'Ricki',
    lastName: 'Fischer',
    id: '884638-107',
  },
  {
    label: 'Doris Haag',
    value: '884637-143',
    type: 'STUDENT_TYPE',
    firstName: 'Doris',
    lastName: 'Haag',
    id: '884637-143',
  },
  {
    label: 'Thomas Mancia',
    value: '884637-132',
    type: 'STUDENT_TYPE',
    firstName: 'Thomas',
    lastName: 'Mancia',
    id: '884637-132',
  },
  {
    label: 'Barbara Moore',
    value: '884637-134',
    type: 'STUDENT_TYPE',
    firstName: 'Barbara',
    lastName: 'Moore',
    id: '884637-134',
  },
  {
    label: 'Jessica Norton',
    value: '884637-127',
    type: 'STUDENT_TYPE',
    firstName: 'Jessica',
    lastName: 'Norton',
    id: '884637-127',
  },
  {
    label: 'Brent Paduano',
    value: '884637-130',
    type: 'STUDENT_TYPE',
    firstName: 'Brent',
    lastName: 'Paduano',
    id: '884637-130',
  },
  {
    label: 'Myrtle Parker',
    value: '884637-131',
    type: 'STUDENT_TYPE',
    firstName: 'Myrtle',
    lastName: 'Parker',
    id: '884637-131',
  },
  {
    label: 'Tona Peters',
    value: '884638-112',
    type: 'STUDENT_TYPE',
    firstName: 'Tona',
    lastName: 'Peters',
    id: '884638-112',
  },
  {
    label: 'Amy Piper',
    value: '884637-126',
    type: 'STUDENT_TYPE',
    firstName: 'Amy',
    lastName: 'Piper',
    id: '884637-126',
  },
  {
    label: 'Shelby Rieger',
    value: '884637-147',
    type: 'STUDENT_TYPE',
    firstName: 'Shelby',
    lastName: 'Rieger',
    id: '884637-147',
  },
  {
    label: 'Ruth Robbins',
    value: '884637-141',
    type: 'STUDENT_TYPE',
    firstName: 'Ruth',
    lastName: 'Robbins',
    id: '884637-141',
  },
  {
    label: 'Susan Rowe',
    value: '884637-144',
    type: 'STUDENT_TYPE',
    firstName: 'Susan',
    lastName: 'Rowe',
    id: '884637-144',
  },
  {
    label: 'Shirley Sanders',
    value: '884637-128',
    type: 'STUDENT_TYPE',
    firstName: 'Shirley',
    lastName: 'Sanders',
    id: '884637-128',
  },
  {
    label: 'Jacqueline Thresher',
    value: '884637-145',
    type: 'STUDENT_TYPE',
    firstName: 'Jacqueline',
    lastName: 'Thresher',
    id: '884637-145',
  },
  {
    label: 'Sydney Turner',
    value: '884637-146',
    type: 'STUDENT_TYPE',
    firstName: 'Sydney',
    lastName: 'Turner',
    id: '884637-146',
  },
  {
    label: 'Emily Waller',
    value: '884637-149',
    type: 'STUDENT_TYPE',
    firstName: 'Emily',
    lastName: 'Waller',
    id: '884637-149',
  },
  {
    label: 'Harold Watson',
    value: '884637-133',
    type: 'STUDENT_TYPE',
    firstName: 'Harold',
    lastName: 'Watson',
    id: '884637-133',
  },
  {
    label: 'Kelley Wilson',
    value: '884637-140',
    type: 'STUDENT_TYPE',
    firstName: 'Kelley',
    lastName: 'Wilson',
    id: '884637-140',
  },
];
